import { Modal, Grid, Link, Box, Button } from "@material-ui/core";
import React, { useEffect, useState } from "react";

interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
  p1?: any;
  p2?: any;
  p3?: any;
}

const DeletePopup: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
  p1,
  p2,
  p3,
}) => {
  const [deleteStatus, setDeleteStatus] = React.useState(open_status);
  const [deleteStatusStep, setDeleteStatusStep] = React.useState(1);

  const handleClick = () => {
    setDeleteStatusStep(2);
  };

  const updateMasterState = (
    attrName: any,
    value: string | boolean | number
  ) => {
    attrName(value);
  };

  useEffect(() => {
    setDeleteStatus(open_status);
  }, []);
  return (
    <Modal open={open_status} className="modalWrapper">
      <>
        {deleteStatusStep === 1 ? (
          <Box className="modalInner deletepopup">
            <Grid container spacing={1}>
              <Grid xs={12}>
                <Link
                  className="close-button"
                  onClick={() => {
                    value_update(attrName, false);
                  }}
                />
                <div className="img-prt">
                  <img
                    src="./images/deletepopup_deleteicon.svg"
                    alt=""
                    className="img"
                  />
                </div>
                <h5 className="popup-heading">{p1}</h5>
              </Grid>
              <Grid xs={12}>
                <p className="md-link mb-10">{p2}</p>
              </Grid>
              <Grid
                xs={12}
                className="ctaBtn"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <Button
                  variant="contained"
                  className="submitBtn"
                  onClick={handleClick}
                >
                  Yes, Delete
                </Button>
                <Button
                  variant="contained"
                  className="cancelBtn"
                  onClick={() => {
                    value_update(attrName, false);
                  }}
                >
                  cancel
                </Button>
              </Grid>
            </Grid>
          </Box>
        ) : deleteStatusStep === 2 ? (
          <Box className="modalInner deletepopup">
            <Grid container spacing={1}>
              <Grid xs={12}>
                <Link
                  className="close-button"
                  onClick={() => {
                    value_update(attrName, false);
                  }}
                />
                <div className="img-prt">
                  <img
                    src="./images/deletePopup_tickicon.svg"
                    alt=""
                    className="img"
                  />
                </div>
                <h5 className="popup-heading">Deleted Successfully!</h5>
              </Grid>
              <Grid xs={12}>
                <p className="md-link mb-10">{p3}</p>
              </Grid>
              <Grid xs={12} className="ctaBtn" style={{ textAlign: "center" }}>
                <Button
                  variant="contained"
                  className="submitBtn"
                  onClick={() => {
                    value_update(attrName, false);
                    setDeleteStatusStep(1);
                  }}
                >
                  Okay
                </Button>
              </Grid>
            </Grid>
          </Box>
        ) : null}
      </>
    </Modal>
  );
};

export default DeletePopup;
